import React, { Component, useState } from 'react'
import ReactApexChart from 'react-apexcharts'
import dayjs from 'dayjs'

export default function ElectricalUnit({ valueTotalElectric }) {
  const [tickAmount, setTickAmount] = useState(valueTotalElectric?.length)
  const [valueFormat, setValueFormat] = useState('DD MMM')
  //console.log('valueElectric', valueTotalElectric)

  const series = [
    {
      name: 'ปริมาณหน่วยไฟฟ้าสะสม',
      type: 'column',
      data: valueTotalElectric,
      //data: [440, 505, 414, 671, 227, 413, 201, 352, 752, 320, 257, 160],
    },
  ]
  const options = {
    chart: {
      height: 350,
      type: 'line',
    },
    stroke: {
      width: [0, 4],
    },
    dataLabels: {
      enabled: true,
      enabledOnSeries: [1],
    },

    xaxis: {
      type: 'datetime',
      labels: {
        formatter: (value) => dayjs(value).locale('th').format(valueFormat),
      },
      tickAmount,
    },
    yaxis: [
      {
        title: {
          text: 'ปริมาณหน่วยไฟฟ้าสะสม',
        },
      },
    ],
  }

  return (
    <div id="chart">
      <ReactApexChart
        options={options}
        series={series}
        type="line"
        height={350}
      />
    </div>
  )
}
